/**
 * 存货列表
 */
import React from 'react';
import { SearchBar, PullRefresh, ProgressState, CheckButton, Ticon } from '../../index';
import { observer } from 'mutants-microfx';
import PartnerStore from './store';
import { InputItem, Checkbox, Icon, ActionSheet } from 'antd-mobile';
import './index.less';
import { TopNavPage, NavUtils } from 'mutants-mobile-navigator';
import { phoneCall} from 'mutants-jsbridge';
import tools from '../../utils/tools'
import env from 'mutants-env';
import {LightAppUtil} from 'tplus-voucher'
import phoneImg from '../../images/newPhone.png'
import { tools as vTools} from 'tplus-voucher';

@observer
@TopNavPage
export default class RefPartner extends React.Component {

  isBottomLine = false

  navTitle() {
    const title = this.props.location && this.props.location.state && this.props.location.state.isSupplier ? '供应商参照' : '客户参照'
    return title;
  }

  listClick = (rowID) => {
    let data = rowID >=0 ? this.store.displayData[rowID] : { ID: null, Name: null, Code: null };
    console.log('选择客户 => ', data);

    if (this.props.location.state.backResultKey) {
      NavUtils.popAndReturn('ok', {
        type: 'refOK',
        selected: [data],
        filedInfo: this.props.location.state.filedInfo,
      }, this.props.location.state.backResultKey);
      return;
    }

    this.popAndReturn('ok', {
      type: 'refOK',
      selected: [data],
      filedInfo: this.props.location.state.filedInfo
    });
  }

  navRightContent() {
    return (
        <div className='navRight'>
          <div className='' style={{marginRight:"0.05rem"}} onClick={this.clearRightButton}>清空</div>
          <div className='' onClick={this.add}><Ticon type='tianjia' /></div>
        </div>
    )
  }

  clearRightButton = () => {
    this.listClick(-1);
  }

  add = () =>{
    LightAppUtil.invokeLightApp('1245', {})
  }

  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    }
    this.store = new PartnerStore();
    this.store.changeFilterParams('PartnerType', this.props.location.state.isSupplier ? '00' : '01')
    this.store.init();
    
    const params = {
      onShow:this.onShow,
      onHide:this.onHide
    }

    if( env.platform === env.constant.platform.yonyou && window.YYEsnBridge && window.YYEsnBridge.registerLifeCycle){
      window.YYEsnBridge.registerLifeCycle(params);
    }
  }

  onShow = () =>{
    this.store.init();
  }

  onHide = () =>{}


  handleChange = (value) => {
    this.setState({
      searchValue: value
    })
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      this.timer = null;
      this.store.changeFilterParams('KeyWord', this.state.searchValue);
    }, 1000);
  }

  handleLoadMore = (afterMore) => {
    // this.store.loadNext().then(() => {
    // });
    this.store.changeFilterParams('PageIndex', this.store.params.PageIndex + 1)
    afterMore && afterMore(this.store.displayData.length);
  }

  telCall = (rowID, e) => {
    e.stopPropagation();
    console.log('打电话 => ', rowID);
    let data = this.store.displayData[rowID];


    // 获取当前data的电话
    let BUTTONS = [];
    let MobilePhone = data.Contact && data.Contact.MobilePhone || '';
    let TelephoneNo = data.Contact && data.Contact.TelephoneNo || '';

    if (!MobilePhone && !TelephoneNo) {
      return;
    }

    if (MobilePhone) {
      BUTTONS = BUTTONS.concat(MobilePhone.indexOf('/') > -1 ? MobilePhone.split('/') : MobilePhone.split(','));
    }

    if (TelephoneNo) {
      BUTTONS = BUTTONS.concat(TelephoneNo.indexOf('/') > -1 ? TelephoneNo.split('/') : TelephoneNo.split(','));
    }

    BUTTONS.push('取消');
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      cancelButtonText: '取消',
      maskClosable: true
    },
      (buttonIndex) => {
        console.log(BUTTONS[buttonIndex])
        // 打电话
        phoneCall(BUTTONS[buttonIndex]);
      });
  }

  itemRender = (rowData, sectionID, rowID) => {
    let data = this.store.displayData[rowID];
    const APBalanceIsRed = !tools.isEmpty(data.APBalance) && parseFloat(data.APBalance) <0 ? true :false;
    const AdvPBalanceIsRed = !tools.isEmpty(data.AdvPBalance) && parseFloat(data.AdvPBalance) <0 ? true :false;
    const isShwoAbbName = !tools.isEmpty(data.PartnerAbbName) && data.PartnerAbbName!=data.Name;
    const splitChat = data.Contact.MobilePhone && data.Contact.TelephoneNo ? '/':'';
    return (
      <div key={rowID} className='row' onClick={this.listClick.bind(this, rowID)}>
        <div className='content'>
          <div className='content-name'>{data.Name} {data.Code ? `(${data.Code})` : ''}</div>
          {isShwoAbbName && <div className='content-abbName'>{data.PartnerAbbName}</div>}
          {
            data.Contact &&
            <React.Fragment>
              <div className='content-contact line-overflow-1'>
                {data.Contact.Name} 
                {`${data.Contact.MobilePhone}${splitChat}${data.Contact.TelephoneNo ? data.Contact.TelephoneNo : ''}` }
                {
                  data.Contact && (data.Contact.MobilePhone || data.Contact.TelephoneNo) &&
                  <div className='tel' onClick={this.telCall.bind(this, rowID)}>
                    <img src={phoneImg}></img>
                  </div>
                }
              </div>
              {
                data.Contact.ShipmentAddress &&
                <div className='content-address line-overflow-1'>{data.Contact.ShipmentAddress}</div>
              }
            </React.Fragment>
          }
          {
            this.props.location.state && this.props.location.state.isSupplier &&
            <div className='subInfos'>
              <div><span>应付余额:</span><span className={APBalanceIsRed ? "red" : ""}>{tools.fixedNum(data.APBalance, 2)}</span></div>
              <div><span>预付余额:</span><span className={AdvPBalanceIsRed ? "red" : ""}>{tools.fixedNum(data.AdvPBalance, 2)}</span></div>
            </div>
          }
        </div>
        {/* {
          data.Contact && (data.Contact.MobilePhone || data.Contact.TelephoneNo) &&
          <div className='tel' onClick={this.telCall.bind(this, rowID)}>
            <img src={phoneImg}></img>
          </div>
        } */}

      </div>
    );
  };

  genData = (dataSize) => {
    // const selecteds = this.store.selecteds.map(item=>{
    //   return item.ID;
    // });

    const dataArr = [];
    for (let i = 0; i < dataSize; i++) {
      let a = Math.random();
      dataArr.push(`row - ${this.store.displayData[i]["ID"]} -`);
    }
    return dataArr;

    // return [...this.store.displayData];
  }

  changeFilterParams = (type, value) => {
    this.store.changeFilterParams(type, value);
  }

  // 商品分类
  groupCallBack = (id) => {
    console.log('Partner id', id);
    this.changeFilterParams('ClassID', id);
  }

  scan = () => {
    console.log('点击了扫码');
  }


  render() {
    const fonts = vTools.getLocalCache('fonts');
    const className = fonts && fonts.ID == '1' ? 'partner-list-X' : 'partner-list'
    let { searchValue } = this.state;
    const dataLength = this.store.displayData ? this.store.displayData.length : 0
    return (
      <div className={className}>
        <SearchBar
          onChange={this.handleChange}
          value={searchValue}
          dtoName='PartnerDTO'
          groupCallBack={this.groupCallBack}
          groupActived={!!this.store.params.ClassID}
          groupSeleted={this.store.params.ClassID}
          placeholder={'搜索' + (this.store.refTitle || '')}>
        </SearchBar>
        <ProgressState
          state={this.store.loaded ? (dataLength > 0 ? 'show' : 'empty') : 'load'}
          empty={{ info: '亲，还没有相关的数据哦~' }}
          error={{ info: '哎呀, 发生错误了~' }}>
          <div className='body'>
            <PullRefresh
              dataSize={dataLength}
              initialListSize={12}
              useBodyScroll={false}
              onMore={this.store.IsNextPage ? this.handleLoadMore : undefined}
              itemRender={this.itemRender}
              genData={this.genData}
              separatorStyle={{}}
              footerStyle={{}} />
          </div>
        </ProgressState>
      </div>
    )
  }
}